export default "__VITE_ASSET__Dur_ay5S__"